import { TStatus, TPaymentMode } from '../../apis/finance/finance.interfaces';
import { TStudentFees } from '../../apis/admissions/adminssionFees.interfaces';

export const studentFeesPartialMock: TStudentFees = {
  studentId: '987654321',
  academicYear: '2023-2024',
  totalFee: 100000,
  feeComponents: [
    {
      id: '123456789',
      componentId: '123456789',
      description: 'Hostel Fee for the academic year 2023-2024',
      componentName: 'Hostel',
      amount: 40000,
      dueDate: new Date('2024-02-15').toISOString(),
      status: TStatus.UNPAID,
      paidAmount: 20000,
      createdBy: '123456789',
      instituteRef: '123456789',
      purpose: 'hostel',
      academicYear: 2023,
    },
    {
      id: '223456789',
      componentId: '123456789',
      description: 'Library Fee for the academic year 2023-2024',
      componentName: 'Library',
      amount: 5000,
      dueDate: new Date('2024-01-10').toISOString(),
      status: TStatus.PAID,
      paidAmount: 5000,
      createdBy: '123456789',
      instituteRef: '123456789',
      purpose: 'library',
      academicYear: 2023,
    },
    {
      id: '323456789',
      componentId: '123456789',
      description: 'Lab Fee for the academic year 2023-2024',
      componentName: 'Lab',
      amount: 20000,
      dueDate: new Date('2024-03-01').toISOString(),
      status: TStatus.UNPAID,
      paidAmount: 0,
      createdBy: '123456789',
      instituteRef: '123456789',
      purpose: 'lab',
      academicYear: 2023,
    },
    {
      id: '423456789',
      componentId: '123456789',
      description: 'Tuition Fee for the academic year 2023-2024',
      componentName: 'Tuition',
      amount: 35000,
      dueDate: new Date('2024-06-01').toISOString(),
      status: TStatus.UNPAID,
      paidAmount: 15000,
      createdBy: '123456789',
      instituteRef: '123456789',
      purpose: 'tuition',
      academicYear: 2023,
    },
  ],
  totalPaid: 40000,
  outstandingBalance: 60000,
  paymentHistory: [
    {
      paymentDate: new Date('2024-01-05'),
      paymentMode: TPaymentMode.ONLINE,
      amountPaid: 20000,
      referenceId: 'PAY123456789',
    },
    {
      paymentDate: new Date('2024-02-01'),
      paymentMode: TPaymentMode.CASH,
      amountPaid: 20000,
    },
  ],
  status: TStatus.PARTIAL,
};

export const studentFeesPaidMock: TStudentFees = {
  studentId: '123456789',
  academicYear: '2023-2024',
  totalFee: 100000,
  feeComponents: [
    {
      id: '123456789',
      componentId: '123456789',
      description: 'Hostel Fee for the academic year 2023-2024',
      componentName: 'Hostel',
      amount: 40000,
      dueDate: new Date('2024-02-13').toISOString(),
      status: TStatus.PAID,
      paidAmount: 40000,
      createdBy: '123456789',
      instituteRef: '123456789',
      purpose: 'hostel',
      academicYear: 2023,
    },
    {
      id: '223456789',
      componentId: '123456789',
      description: 'Library Fee for the academic year 2023-2024',
      componentName: 'Library',
      amount: 5000,
      dueDate: new Date('2024-01-11').toISOString(),
      status: TStatus.PAID,
      paidAmount: 5000,
      createdBy: '123456789',
      instituteRef: '123456789',
      purpose: 'library',
      academicYear: 2023,
    },
    {
      id: '323456789',
      componentId: '123456789',
      description: 'Lab Fee for the academic year 2023-2024',
      componentName: 'Lab',
      amount: 20000,
      dueDate: new Date('2024-03-04').toISOString(),
      status: TStatus.PAID,
      paidAmount: 20000,
      createdBy: '123456789',
      instituteRef: '123456789',
      purpose: 'lab',
      academicYear: 2023,
    },
    {
      id: '423456789',
      componentId: '12346789',
      description: 'Tuition Fee for the academic year 2023-2024',
      componentName: 'Tuition',
      amount: 35000,
      dueDate: new Date('2024-06-05').toISOString(),
      status: TStatus.PAID,
      paidAmount: 35000,
      createdBy: '123456789',
      instituteRef: '123456789',
      purpose: 'tuition',
      academicYear: 2023,
    },
  ],
  totalPaid: 100000,
  outstandingBalance: 0,
  paymentHistory: [
    {
      paymentDate: new Date('2024-01-12'),
      paymentMode: TPaymentMode.ONLINE,
      amountPaid: 35000,
      referenceId: 'PAY123456789',
    },
    {
      paymentDate: new Date('2024-03-05'),
      paymentMode: TPaymentMode.CASH,
      amountPaid: 65000,
    },
  ],
  status: TStatus.PAID,
};
